import {withTranslation} from "react-i18next";
import {
    InfoCircleOutlined, LeftOutlined
} from '@ant-design/icons';
import "../cervo.scss";
import {Button, Tooltip} from 'antd';
import {history} from '_helpers/history'

import Headerbutton from "../../../component/headerButton";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";

function StepCervoFive(props) {
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const user = JSON.parse(storage.getItem(variables.USER));
    const {t} =props;

    const saveAndContinue = () => {
        history.push("/admin/assessment")
    }

    const copyCervo = () => <p className={"tooltip-text"} dangerouslySetInnerHTML={{__html: t('cervo.copycervo')}}></p>

    return (
      <>
          <div className={"containerStartCervoTwo wrapper"}>
              <div className={"insideCervo boxed"}>
                  <Headerbutton  saveAndContinue={saveAndContinue}  />
              </div>
              <div className={"container-pre-question boxed"}>
                  <div className={"content-pre-question"}>
                      <div className={"content-text-scroll"}>
                          <p className={"pre-question-title"}>{t("cervo.precuestionariotitle1")}</p>
                          <p className={"pre-question-title"}>
                              {t("cervo.precuestionariotitle2")}&nbsp;
                              <Tooltip
                                overlayStyle={{maxWidth: 500}}
                                title={copyCervo}
                              >
                                  <InfoCircleOutlined />
                              </Tooltip>
                          </p>
                          <p className={"pre-question-subtitle"}>{t("ceiba.init3")}</p>
                          <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('cervo.infol1')}} />
                          <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('cervo.infol2')}} />
                          <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('cervo.infol3')}} />
                          <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('cervo.infol4').replace("#name#", user.name)}} />
                          <p className={"pre-question-list"} dangerouslySetInnerHTML={{__html: t('cervo.infol5')}} />
                      </div>
                      <Button type={"primary"}
                              onClick={() => history.push("/admin/start-cervo")}
                              className="primaryButton btn-start">{t("cervo.starcuestionario")}</Button>
                  </div>
                  <Button type="link"
                          icon={<LeftOutlined />}
                          onClick={() => props.goTo(5)}
                          className={"btn-back"}

                  >
                      {t("atras")}
                  </Button>
              </div>
              <div className={"footerCervo"}>
                  <p dangerouslySetInnerHTML={{__html: t('cervo.copycervo')}} />
              </div>

          </div>
      </>

    )
}

export default withTranslation()(StepCervoFive);
